<template>
  <v-container id="report" fluid>
    <timeline-dashboard />
    <eye-tracking-dashboard />
  </v-container>
</template>

<script>
import TimelineDashboard from '@/components/report/TimelineDashboard'
import EyeTrackingDashboard from '@/components/report/EyeTrackingDashboard'

export default {
  name: 'ReportDashboard',
  components: {
    TimelineDashboard,
    EyeTrackingDashboard
  },
  data: () => ({}),
  methods: {},
  created() {}
}
</script>

<style scoped></style>
